// React imports.
import React from "react";

import { Assessment3aStepsEnum } from "../state";
import { Assessment3aVendorAssignedStatusEnum } from "../state";
const Assessment3aQuestions = ({fuelType, state}) => (
    <div>
        {/*OverTargetNoIssues*/}
        {(fuelType.vendorAssignmentStatus == Assessment3aVendorAssignedStatusEnum.Over95NoIssues
            &&fuelType.viewAnywayFlag != true)
          &&<p>
              This means that you likely do not have a data reliability issue with regard  
              to your client application for    {fuelType.description}    households.
              No further action is required for    {fuelType.description}    households
              in Assessment #3A. If you want to analyze potential data reliability
              issues for    {fuelType.description}    data anyway,  
              click &nbsp;<button className="dataButton"
                        onClick={(changeEvent) => state.assessment3aViewAnyway(changeEvent, fuelType)}>
                        here
                    </button>. Otherwise, click next.
          </p>
        }
        {/*NoHouseholdsServed*/}
        {(fuelType.vendorAssignmentStatus == Assessment3aVendorAssignedStatusEnum.NoHouseholdsServed)
          &&<p>
              No further action is required for   {fuelType.description}   households
              in Assessment #3a.  Click next to continue.
          </p>
        }

        {(fuelType.vendorAssignmentStatus == Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget
            || fuelType.viewAnywayFlag === true)
          &&
          <React.Fragment>
              {(fuelType.vendorAssignmentStatus == Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget)
              &&<div>
                  <p>
                      The fact that less than 95% of your assisted   {fuelType.description}  households  
                      are assigned to an electric vendor indicates that you may not be  
                      processing LIHEAP applications correctly and/or you may not be  
                      correctly accounting for the number of households being assisted  
                      by each vendor. Additionally, having a high percentage of your  
                      households assigned to a vendor is important for other things,  
                      such as ensuring that vendors are paid properly for the assisted  
                      households they serve.  In order to address this issue, you will  
                      likely need to revise your LIHEAP client application or and/or  
                      client waiver. 
                  </p>
                  <p>Let's explore some reasons why you might have that result.</p>
                  <ol >
                      <li>
                          The LIHEAP application doesn&rsquo;t include electric 
                          vendor name and account number for households 
                          that do not heat with electricity. 
                      </li>
                      <li>
                          The LIHEAP application does not make it clear that 
                          the provision of the client&rsquo;s electric vendor 
                          and account number are required fields, even when 
                          the household does not plan to apply their LIHEAP 
                          benefit to their electric provider.
                      </li>
                      <li>
                          The staff at one or more of your intake agencies 
                          are not following up with applicants who did not 
                          include their baseload electricity provider and 
                          account number on their application. 
                      </li>
                  </ol>
                  <p>
                      Let's walk through each of these issues so 
                      that you can assess whether any of them might 
                      be a problem for your data.
                  </p>
              </div>}  
              <p>
                  Please answer each 
                  of the questions below. Depending on your response, 
                  each question may ask you to outline an action item 
                  to help you address the issue. <strong>If you don't 
                  know the answer to a question please indicate "Don't Know" 
                  and provide your plans to acquire this information from 
                  IT department or programming staff in the response box.</strong>
              </p>
              <ol>
                  {/*appIncludesVendorAndAcctNo*/}
                    <li>
                        Does your LIHEAP application ask for the client’s electric vendor and account number even when the household does not heat with electricity?
                        <br/>
                        <label>
                            <input type="radio"
                                name="appIncludesVendorAndAcctNoFlag"
                                id="appIncludesVendorAndAcctNoFlag_true"
                                value="Y"
                                checked={fuelType.appIncludesVendorAndAcctNoFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="appIncludesVendorAndAcctNoFlag"
                                id="appIncludesVendorAndAcctNoFlag_false"
                                value="N"
                                checked={fuelType.appIncludesVendorAndAcctNoFlag === "N"}
                                onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="appIncludesVendorAndAcctNoFlag"
                                id="appIncludesVendorAndAcctNoFlag_dk"
                                value="U"
                                checked={fuelType.appIncludesVendorAndAcctNoFlag === "U"}
                                onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {fuelType.appIncludesVendorAndAcctNoFlag === "Y"
                          && <span>
                              <strong>No action needed.</strong>   
                              The LIHEAP application should ask for the vendor and account number of all applicants. 
                            </span>
                          }
                        {fuelType.appIncludesVendorAndAcctNoFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must acquire electric billing data on households that heat  
                              with fuels other than electricity. To acquire this information,  
                              you must know the electric vendor and account number of each  
                              LIHEAP participating household so that you can match data on  
                              heat and electric bills to LIHEAP clients. You must request this  
                              information on the LIHEAP application. 

                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="appIncludesVendorAndAcctNoDesc"
                                  id="appIncludesVendorAndAcctNoDesc" style={{width:"100%"}}
                                  value={fuelType.appIncludesVendorAndAcctNoDesc}
                                  onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        {fuelType.appIncludesVendorAndAcctNoFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know whether your LIHEAP application asks for a client's  
                              electric vendor and account number regardless of the client's  
                              heating fuel in order to complete a full assessment. You may  
                              need to consult your current LIHEAP application or request  
                              subgrantees provide you with the local applications they use.  
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="appIncludesVendorAndAcctNoDesc"
                                  id="appIncludesVendorAndAcctNoDesc" style={{width:"100%"}}
                                  value={fuelType.appIncludesVendorAndAcctNoDesc}
                                  onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>

                    {/*appVendorAndAcctNoRequiredField*/}
                    <li>
                        Does your LIHEAP application make it clear that the provision of the client’s electric vendor and account number are required fields, even when the household does not plan to apply their LIHEAP benefit to their electric provider?
                        <br/>
                        <label>
                            <input type="radio"
                                name="appVendorAndAcctNoRequiredFieldFlag"
                                id="appVendorAndAcctNoRequiredFieldFlag_true"
                                value="Y"
                                checked={fuelType.appVendorAndAcctNoRequiredFieldFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="appVendorAndAcctNoRequiredFieldFlag"
                                id="appVendorAndAcctNoRequiredFieldFlag_false"
                                value="N"
                                checked={fuelType.appVendorAndAcctNoRequiredFieldFlag === "N"}
                                onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="appVendorAndAcctNoRequiredFieldFlag"
                                id="appVendorAndAcctNoRequiredFieldFlag_dk"
                                value="U"
                                checked={fuelType.appVendorAndAcctNoRequiredFieldFlag === "U"}
                                onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {fuelType.appVendorAndAcctNoRequiredFieldFlag === "Y"
                          && <span>
                              <strong>No action needed.</strong>   
                              The LIHEAP application should make clear that electric vendor and account number are required fields for all applicants.
                            </span>
                          }
                        {fuelType.appVendorAndAcctNoRequiredFieldFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must acquire electric billing data on households that heat with fuels  
                              other than electricity. To acquire this information, you must know the  
                              electric vendor and account number of each LIHEAP participating household  
                              so that you can match data on heat and electric bills to LIHEAP clients.  
                              Be sure the LIHEAP application makes clear that this information is  
                              needed for <i>all</i> clients. 
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="appVendorAndAcctNoRequiredFieldDesc"
                                  id="appVendorAndAcctNoRequiredFieldDesc" style={{width:"100%"}}
                                  value={fuelType.appVendorAndAcctNoRequiredFieldDesc}
                                  onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        {fuelType.appVendorAndAcctNoRequiredFieldFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know whether your LIHEAP application asks clearly for a client's electric
                              vendor and account number regardless of the client's heating fuel in order to
                              complete a full assessment. You may need to consult your current LIHEAP application
                              or request subgrantees provide you with the local applications they use.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="appVendorAndAcctNoRequiredFieldDesc"
                                  id="appVendorAndAcctNoRequiredFieldDesc" style={{width:"100%"}}
                                  value={fuelType.appVendorAndAcctNoRequiredFieldDesc}
                                  onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>
                    {/*intakeFollowupMissingVendor*/}
                    <li>
                        Are the staff at intake agencies instructed to follow-up with LIHEAP applicants who fail to provide their electric vendor and account number at the time of application? 
                        <br/>
                        <label>
                            <input type="radio"
                                name="intakeFollowupMissingVendorFlag"
                                id="intakeFollowupMissingVendorFlag_true"
                                value="Y"
                                checked={fuelType.intakeFollowupMissingVendorFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="intakeFollowupMissingVendorFlag"
                                id="intakeFollowupMissingVendorFlag_false"
                                value="N"
                                checked={fuelType.intakeFollowupMissingVendorFlag === "N"}
                                onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="intakeFollowupMissingVendorFlag"
                                id="intakeFollowupMissingVendorFlag_dk"
                                value="U"
                                checked={fuelType.intakeFollowupMissingVendorFlag === "U"}
                                onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {fuelType.intakeFollowupMissingVendorFlag === "Y"
                          && <span>
                              <strong>No action needed.</strong>   
                              Staff at intake agencies should be instructed to follow up with all applicants who
                              fail to provide vendors and account numbers.
                            </span>
                          }
                        {fuelType.intakeFollowupMissingVendorFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must acquire electric billing data on households that heat with fuels other than
                              electricity. To acquire this information, you must know the electric vendor and
                              account number of each LIHEAP participating household so that you can match data
                              on heat and electric bills to LIHEAP clients. Communicate with frontline staff
                              and subgrantees to ensure that they acquire this information, even when the
                              household does not heat with electricity. 
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="intakeFollowupMissingVendorDesc"
                                  id="intakeFollowupMissingVendorDesc" style={{width:"100%"}}
                                  value={fuelType.intakeFollowupMissingVendorDesc}
                                  onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        {fuelType.intakeFollowupMissingVendorFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know whether frontline staff and subgrantees are instructed to follow up on
                              clients who did not provide account and vendor information in order to complete a full
                              assessment. You may need to consult your staff and subgrantees to find out this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="intakeFollowupMissingVendorDesc"
                                  id="intakeFollowupMissingVendorDesc" style={{width:"100%"}}
                                  value={fuelType.intakeFollowupMissingVendorDesc}
                                  onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>

                  {((fuelType.appIncludesVendorAndAcctNoFlag === "Y")
                      &&(fuelType.appVendorAndAcctNoRequiredFieldFlag ===  "Y")
                      &&(fuelType.intakeFollowupMissingVendorFlag ===  "Y"))
                      &&<li>
                          It appears that your potential data reliability issue cannot be explained by the most common
                          reasons we have found for why states might not have an electric vendor assigned for at least
                          95% of their assisted households. Please contact APPRISE to discuss other potential explanations
                          for this discrepancy. If you have any ideas about what might be causing the discrepancy, please
                          document it in the response box below.
                          
                          <textarea  name="otherReasonDesc"
                                id="otherReasonDesc" style={{width:"100%"}}
                                value={fuelType.otherReasonDesc}
                                onChange={(changeEvent) => state.assessment3aFieldChangeHandler(changeEvent, fuelType)}></textarea>
                      </li>
                  }               
              </ol>
          </React.Fragment>
        }
    </div>
);
export default Assessment3aQuestions;
